import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom'

import PackageCardAlpha from "./../packageSidebar/PackageCardAlpha";

const scrollTop = () => { window.scrollTo({ top: 0, behavior: "smooth" }) }

function FrontpageSelection() {


  // API configuration constants
  const API_URL = "https://test.campfr.com/api/list_frontpage_selection/";
  // const API_URL = "http://localhost:8000/api/list_featured_workshops/";
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;


  // Define a color mapping for the 10 artforms.
  const artformColors = {
    music: "#367591",
    sound: "#009FE3",
    film: "#FBF299",
    art: "#E6007E",
    environment: "#6EBC86",
    writing: "#7B6A58",
    activism: "#E24259",
    performance: "#725283",
    video: "#ABD194",
    vr: "#4D4C4C"
  };

  // State management for data, loading status, and error handling
  const [wsGroups, setwsGroups] = useState([]);
  const [allWorkshops, setAllWorkshops] = useState([]);
  const [onsiteWorkshops, setOnsiteWorkshops] = useState([]);
  const [onlineWorkshops, setOnlineWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    /**
     * Fetches data from the API with authentication token
     */

    const fetchData = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "X-API-TOKEN": API_TOKEN }
        });

        console.log("API Response:", response.data);

        // Update component state with fetched data
        const data = response.data; // Use the response data directly
        setwsGroups(data);
        setAllWorkshops(data.allw);
        setOnsiteWorkshops(data.onsite);
        setOnlineWorkshops(data.online);

        setLoading(false);
      } catch (error) {
        console.error("API Error:", error);
        setError(error.message || "Failed to fetch API");
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this effect runs once on mount

  console.log(error);

  // Map over the fetched workshops to render slides

  //ALL WORKSHOPS
  const wsjsx_all = allWorkshops.map((workshop, wgindex) => {

    // Convert the comma-separated artforms string into an array
    const artformTags = workshop.artforms.split(',').map((art, idx) => {
      const trimmedArt = art.trim();
      return (
        <span
          key={idx}
          style={{
            backgroundColor: artformColors[trimmedArt],
            color: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "0.9rem",
            marginRight: "4px",
            marginBottom: "4px"
          }}
        >
          {trimmedArt}
        </span>
      );
    });

    const tutorColorClasses = ['txt-gradient-1', 'txt-gradient-2', 'txt-gradient-3', 'txt-gradient-4', 'txt-gradient-5', 'txt-gradient-6'];
    const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

    return (
      <div className="col-lg-4 col-md-6 fadeffect">
        <PackageCardAlpha workshop={workshop} />

      </div>

    );
  });


  //ONSITE WORKSHOPS
  const wsjsx_onsite = onsiteWorkshops.map((workshop, wgindex) => {

    // Convert the comma-separated artforms string into an array
    const artformTags = workshop.artforms.split(',').map((art, idx) => {
      const trimmedArt = art.trim();
      return (
        <span
          key={idx}
          style={{
            backgroundColor: artformColors[trimmedArt],
            color: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "0.9rem",
            marginRight: "4px",
            marginBottom: "4px"
          }}
        >
          {trimmedArt}
        </span>
      );
    });

    const tutorColorClasses = ['txt-gradient-1', 'txt-gradient-2', 'txt-gradient-3', 'txt-gradient-4', 'txt-gradient-5', 'txt-gradient-6'];
    const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

    return (
      <div className="col-lg-4 col-md-6 fadeffect">
        <PackageCardAlpha workshop={workshop} />

      </div>

    );
  });


  //ONLINE WORKSHOPS
  const wsjsx_online = onlineWorkshops.map((workshop, wgindex) => {

    // Convert the comma-separated artforms string into an array
    const artformTags = workshop.artforms.split(',').map((art, idx) => {
      const trimmedArt = art.trim();
      return (
        <span
          key={idx}
          style={{
            backgroundColor: artformColors[trimmedArt],
            color: "white",
            borderRadius: "8px",
            padding: "4px 8px",
            fontSize: "0.9rem",
            marginRight: "4px",
            marginBottom: "4px"
          }}
        >
          {trimmedArt}
        </span>
      );
    });

    const tutorColorClasses = ['txt-gradient-1', 'txt-gradient-2', 'txt-gradient-3', 'txt-gradient-4', 'txt-gradient-5', 'txt-gradient-6'];
    const randomTutorClass = tutorColorClasses[Math.floor(Math.random() * tutorColorClasses.length)];

    return (
      <div className="col-lg-4 col-md-6 fadeffect">
        <PackageCardAlpha workshop={workshop} />

      </div>

    );
  });



  return (
    <>
      <div className="package-area offer-package-style-one pt-110 pb-110">
        <div className="container">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-6 col-sm-10">
              <div className="section-head-alpha">
                <h2>Coming Up</h2>
                <p>Here's a taste of what's coming up at CAMP - <a href="/workshops">click here</a> to explore the full program.</p>
              </div>
            </div>
            <div className="col-lg-6 col-sm-10">
              <div className="package-btn text-lg-end">
                <a href="/workshops" className="button-fill-primary all-package-btn">View all workshops</a>
              </div>
            </div>
          </div>

          <div className="row align-items-center">
            <div className="offer-switch-button2">
              <ul className="nav nav-pills mb-3 justify-content-center gap-sm-4 gap-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="pills-all" data-bs-toggle="pill" data-bs-target="#pills-offer-tab1" type="button" role="tab" aria-controls="pills-offer-tab1" aria-selected="true">All</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-onsite" data-bs-toggle="pill" data-bs-target="#pills-offer-tab2" type="button" role="tab" aria-controls="pills-offer-tab2" aria-selected="false">Onsite</button>
                </li>
                <li className="nav-item" role="presentation">
                  <button className="nav-link" id="pills-online" data-bs-toggle="pill" data-bs-target="#pills-offer-tab3" type="button" role="tab" aria-controls="pills-offer-tab3" aria-selected="false">Online</button>
                </li>
              </ul>
            </div>




            <div className="offer-single-tabs">
              <div className="tab-content" id="pills-tabContent">


                <div className="tab-pane fade show active" id="pills-offer-tab1" role="tabpanel" aria-labelledby="pills-offer1">
                  <div className="row d-flex justify-content-center g-4">

                    {wsjsx_all}

                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <a href="/workshops" className="button-fill-round">View all workshops</a>
                  </div>
                </div>




                <div className="tab-pane fade" id="pills-offer-tab2" role="tabpanel" aria-labelledby="pills-offer2">
                  <div className="row d-flex justify-content-center g-4">


                    {wsjsx_onsite}


                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <a href="/workshops" className="button-fill-round">View all workshops</a>
                  </div>
                </div>





                <div className="tab-pane fade" id="pills-offer-tab3" role="tabpanel" aria-labelledby="pills-offer3">
                  <div className="row d-flex justify-content-center g-4">

                    {wsjsx_online}


                  </div>
                  <div className="package-page-btn text-center mt-60">
                    <a href="/workshops" className="button-fill-round">View all workshops</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FrontpageSelection